import * as z from "zod/v4";
import { InventoryLevelSchema } from "../inventory/inventory";
import { WarehouseSchema } from "../warehouse/warehouse-types";
import {
  Product2AttributeSchema,
  Product2AttributeValueSchema,
} from "./product2-attribute-types";
import {
  Product2ImageSchema,
  Product2Schema_,
  Product2VariantSchema_,
} from "./product2-types";

const InventoryLevelWithWarehouseSchema_ = InventoryLevelSchema.extend({
  warehouse: WarehouseSchema,
});
export const InventoryLevelWithWarehouseSchema: z.ZodType<InventoryLevelWithWarehouse> =
  InventoryLevelWithWarehouseSchema_;
export type InventoryLevelWithWarehouse = z.infer<
  typeof InventoryLevelWithWarehouseSchema_
>;

const VariantWithInventorySchema_ = Product2VariantSchema_.extend({
  inventoryLevels: z.array(InventoryLevelWithWarehouseSchema_),
  available: z.number().min(0).default(0),
  committed: z.number().min(0).default(0),
});
export const VariantWithInventorySchema: z.ZodType<VariantWithInventory> =
  VariantWithInventorySchema_;
export type VariantWithInventory = z.infer<typeof VariantWithInventorySchema_>;

const ProductDetailsSchema_ = Product2Schema_.extend({
  variants: z.array(VariantWithInventorySchema),
  attributes: z.array(Product2AttributeSchema),
});
export const ProductDetailsSchema: z.ZodType<ProductDetails> =
  ProductDetailsSchema_;
export type ProductDetails = z.infer<typeof ProductDetailsSchema_>;

export const VariantDetailsSchema_ = Product2VariantSchema_.extend({
  available: z.number().min(0).default(0),
  attributeValues: z.array(Product2AttributeValueSchema),
  images: z.array(Product2ImageSchema),
  name: z.string(),
  vendor: z.string(),
  description: z.string().optional(),
  productId: z.string(),
});
export const VariantDetailsSchema: z.ZodType<VariantDetails> =
  VariantDetailsSchema_;
export type VariantDetails = z.infer<typeof VariantDetailsSchema_>;
